module.exports = __webpack_public_path__ + "img/wait-join.1a201cc3.png";